<template>
  <div class="course_warp">
    <!-- <div class="back">
      <img src="@/static/back.png"
           @click="back"
           alt="">
    </div> -->
    <div class="top">
       <!-- <img src="@/static/icons/phone.png"  
             alt=""> -->
             <div class="text">如需开通vip</div>
 <div class="text"> 请电话或微信（微信同号）联系客服</div>
    <div class="text1">客服电话①：17790006158<br>
客服电话②：18186857788<br>
客服电话③：13644310332</div>
    </div>
    
  </div>
</template>

<script>
 export default {
  data () {
    return {
      list: [],
      lectureList: [],
      shcoolVideoList: [],
      userInfo:  null,
      autoModalFlag: false
    }
  },

  computed: {

  },
  mounted () {
    
  },
  methods: {
    toBuy () {
      this.$router.push('/buyVip')
    },
    async initData () {
      const { data } = await getHomeLecture()
      // console.log(data)
      this.list = data.list
    },
    async getLecture () {
      const { data } = await getHomeList()
      this.lectureList = data.list
    },
    async getSchool() {
      const { data } = await getSchoolList({edu_school_id:this.userInfo.edu_school_id,type:"video"})
      this.shcoolVideoList = data.list
    },
    toPage (path) {
      this.$router.push(path)
    },
    showVideo (url) {
      // window.open(url, '_blank')
      this.$router.push("/video?video=" + url)
    }
  }
}
</script>

<style lang="scss" scoped>
.course_warp {
  height: 100%;
  .back {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 30rem 30rem 0 50rem;
  cursor: pointer;
  img {
    border-radius: 50%;
    box-shadow: 0px 1px 19px 0px #2f3ad7;
    width: 60rem;
    height: 60rem;
  }
  div {
    margin-right: 10rem;
  }
}
   .top{
    display: flex;
  justify-content: center;
  align-items: center;
  height: 683rem;
  flex-direction: column;
  .text{
    color: #000;
text-align: center;
font-size: 32rem;
font-style: normal;
font-weight: 600;
line-height: 48px; /* 150% */
  }
  .text1{
    color: #000;
font-size: 28rem;
font-style: normal;
font-weight: 400;
line-height: 42px; /* 150% */
  }
   }
    .fixed_wrap {
      width: 50rem;
      height: 50rem;
     margin-left: 40rem;

      .fixed_back_btn {
        cursor: pointer;
        top: 15rem;
        left: 25rem;
        width: 50rem;
      }
    }
   .autoModal {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 1.5;
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 1)
    );
    .btntext {
      position: fixed;
      left: 800rem;
      top: 700rem;
      .text {
        color: var(--light-333333, #333);
        text-align: center;

        font-size: 24rem;
        font-style: normal;
        font-weight: 600;
        line-height: 36rem; /* 150% */
      }
    }
    .openButton {
      ::v-deep .el-button {
        display: flex;
        width: 360rem;
        height: 64rem;
        justify-content: center;
        align-items: center;
        gap: 10rem;
        flex-shrink: 0;
        border-radius: 8rem;
        background: linear-gradient(100deg, #fdecc9 0%, #e9c383 100%);
        box-shadow: 0rem 8rem 16rem 0rem rgba(0, 0, 0, 0.1);
      }
    }
  }
  .top {
    display: flex;
    // overflow: auto;
    // width: 96%;
    // margin: 0 20rem 10rem;
    .card {
      flex: 1;
      margin-top: 3.5vh;
      margin-right: 60rem;
      display: flex;
      .imgItem {
        width: 553rem;
        height: 400rem;
        margin-left: 2.13vw;
        padding: 30rem 40rem;
        color: #fff;
        background-size: 100% 100%;
        box-sizing: border-box;
        border-radius: 24rem;

        .icon {
          width: 35rem;
          height: 36rem;
          margin-right: 16rem;
          display: inline-block;
          img {
            width: 100%;
            height: 100%;
            vertical-align: middle;
          }
        }

        .title {
          font-size: 32rem;
          // padding-left: 16rem;
        }
        .sub_title {
          font-size: 24rem;
          margin-top: 20rem;
          line-height: 30rem;
        }
        .btn {
          font-size: 24rem;
          margin-top: 180rem;
          .icon {
            width: 22rem;
            height: 22rem;
            padding-left: 8rem;
          }
        }
      }
      // img {
      //   // flex: 1;
      //   width: 27vw;
      //   margin-left: 3.13vw;
      // }
    }
  }
  .knowledge {
    margin-top: 30rem;
    width: calc(100% - 120rem);
    margin-left: 60rem;
    .title {
      font-size: 24rem;
      font-weight: bold;
      color: #000000;
      display: flex;
      justify-content: space-between;
      height: 24rem;
      line-height: 24rem;
      img {
        width: 24rem;
        height: 24rem;
        margin-left: 14rem;
      }
    }
    .progress {
      display: flex;
      overflow-x: auto;
      padding-bottom: 10rem;
      .card {
        width: 280rem;
        height: 240rem;
        border-radius: 15rem;
        box-shadow: 0rem 0rem 8rem 4rem rgba(234, 234, 234, 0.5);
        background: #ffffff;
        flex-shrink: 0;
        margin-right: 30rem;
        margin-top: 30rem;
        cursor: pointer;
        .subject {
          width: 120rem;
          height: 44rem;
          border-radius: 1rem 1rem 15rem 15rem;
          position: relative;
          left: 50%;
          transform: translateX(-50%);
          font-size: 20rem;
          font-weight: bold;
          line-height: 28rem;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .name {
          font-weight: bold;
          color: #333333;
          font-size: 20rem;
          margin-top: 20rem;
          width: 240rem;
          height: 56rem;
          margin-left: 20rem;
        }
        .start {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 20rem;
          margin-right: 10rem;
        }
        .btn {
          width: 180rem;
          height: 44rem;
          background: #557ef2;
          border-radius: 40rem;
          font-size: 20rem;
          margin-top: 20rem;
          font-weight: bold;
          color: #ffffff;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          left: 50%;
          transform: translateX(-50%);
          img {
            width: 22rem;
            height: 22rem;
            margin-left: 12rem;
          }
        }
      }
      .card_lecture {
        width: 260rem;
        height: 180rem;
        border-radius: 15rem;
        padding: 10rem;
        box-shadow: 0rem 0rem 8rem 4rem rgba(234, 234, 234, 0.5);
        background: #ffffff;
        flex-shrink: 0;
        margin-right: 30rem;
        margin-top: 30rem;
        cursor: pointer;
        .preview_img {
          margin: 0 auto;
          width: 100%;
          height: 120rem;
          img,
          video {
            width: 100%;
            height: 100%;
            background-size: 80% 100%;
            background-repeat: no-repeat;
            background-position: center;
          }
        }
        .name {
          font-weight: bold;
          color: #333333;
          font-size: 20rem;
          margin-top: 10rem;
          width: 260rem;
          height: 56rem;
          text-align: center;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
        }
      }
      .card_school {
        width: 260rem;
        // height: 180rem;
        border-radius: 15rem;
        padding: 10rem;
        box-shadow: 0rem 0rem 8rem 4rem rgba(234, 234, 234, 0.5);
        background: #ffffff;
        flex-shrink: 0;
        margin-right: 30rem;
        margin-top: 30rem;
        cursor: pointer;
        .preview_img {
          margin: 0 auto;
          width: 100%;
          height: 120rem;
          img,
          video {
            width: 100%;
            height: 100%;
            background-size: 80% 100%;
            background-repeat: no-repeat;
            background-position: center;
          }
        }
        .name {
          font-weight: bold;
          color: #333333;
          font-size: 20rem;
          margin-top: 10rem;
          width: 260rem;
          height: 56rem;
          text-align: center;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
}
/* 整个滚动条 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
/* 滚动条上的按钮 (上下箭头). */
::-webkit-scrollbar-button {
  display: none;
}
/* 滚动条上的滚动滑块. */
::-webkit-scrollbar-thumb {
  background-color: rgba(202, 202, 210, 0.8);
  border-radius: 50px;
  cursor: pointer;
}
/* 滚动条没有滑块的轨道部分 */
::-webkit-scrollbar-track-piece {
  border-radius: 20px;
}
/* 当同时有垂直滚动条和水平滚动条时交汇的部分. */
::-webkit-scrollbar-corner {
  background: transparent;
}
</style>